export default __webpack_public_path__ + "static/media/Shubham_resume.2f57c2cb.pdf";